import { COOKIE_KEYS } from '@moniebook-web/types';
import { removeItem, setItem } from '@moniebook-web/utils';

import type { GhostSessionTokenResponse } from './types';

export const decodeJwtPayload = <Payload>(token: string): Payload | null => {
    try {
        const [, payload] = token.split('.');
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(atob(normalized));
    } catch {
        return null;
    }
};

export const formatGhostSessionCountdown = (remainingMs: number): string => {
    const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value: number) => value.toString().padStart(2, '0');

    return `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
};

export const setupGhostSessionTokenInfo = ({
    accessToken,
    sessionExpiresAt,
}: GhostSessionTokenResponse): void => {
    removeItem(COOKIE_KEYS.REFRESH_TOKEN_VARIABLE);
    removeItem(COOKIE_KEYS.REFRESH_TOKEN_EXPIRY_VARIABLE);
    setItem(COOKIE_KEYS.TOKEN_VARIABLE, accessToken);
    setItem(
        COOKIE_KEYS.TOKEN_EXPIRY_VARIABLE,
        new Date(sessionExpiresAt).toString(),
    );
};
